import { map, pickBy } from 'lodash';

export interface IColumnsCategories {
  name: string;
  resource?: string;
  columnsIds?: string[];
  queryByDefault?: boolean;
}
export const columnsCategories: { [key: string]: IColumnsCategories } = {
  patient: {
    name: 'Patient Info',
  },
  meetings: {
    name: 'Meetings',
    resource: 'meetings',
    columnsIds: ['meeting'],
  },
  currentCourse: {
    name: 'Course',
    resource: 'current_course',
    columnsIds: ['current_course'],
    queryByDefault: true,
  },
  nextCourse: {
    name: 'Course',
    resource: 'next_course',
    columnsIds: ['current_course'],
    queryByDefault: true,
  },
  rtm: {
    name: 'Tracking',
    resource: 'current_rtm_cycle',
    columnsIds: ['activeDays', 'ptTime'],
  },
  rtmChart: {
    name:'rtmChart',
    resource: 'current_rtm_cycle',
    columnsIds: ['rtmChart#1','rtmChart#2'],
  },
  fallRisk: {
    name: 'Fall Risk',
    resource: 'fall_risk',
  },
  changeOfStatus: {
    name: 'Status',
    resource: 'change_of_status',
    columnsIds: ['status'],
  },
  questionnaires: {
    name: 'Questionnaires',
    resource: 'last_questioners',
    columnsIds: ['fes', 'lastActivity'],
    queryByDefault: true,
  },
  measurements: {
    name: 'Measurements',
    resource: 'last_measurements',
    columnsIds: ['lastActivity'],
    queryByDefault: true,
  },
  events: {
    name: 'Events',
    resource: 'events',
    columnsIds: ['lastActivity'],
  },
  featureMap: {
    name: 'featureMap',
    resource: 'feature_map',
    columnsIds: ['fallRisk'],
  },
  tags: {
    /* This is not showing in patients table, we added it to recourses
   because we need it in home page tasks*/
    name: 'tags',
    resource: 'tags',
  },

  latestFallRisk: {
    name: 'latestFallRisk',
    resource: 'latest_fall_risk',
    columnsIds: ['fallRisk'],
  },
  lastMeasurements: {
    name: 'lastMeasurements',
    resource: 'last_measurements',
    columnsIds: ['sts', 'tug', 'lastActivity'],
  },
  surgeries: {
    name: 'surgeries',
    resource: 'surgeries',
    columnsIds: ['surgeryDate'],
  },
  therapistTime: {
    name: 'therapistTime',
    resource: 'therapist_time,last_reported_meeting',
    columnsIds: ['ptTime'],
  },
  countWalksInPeriod7: {
    name: 'countWalksInPeriod7',
    resource: 'walks_in_period',
    columnsIds: ['numberWalksInPeriod7', 'status'],
    queryByDefault: true,
  },
  countWalksInPeriod14: {
    name: 'countWalksInPeriod14',
    resource: 'walks_in_period',
    columnsIds: ['numberWalksInPeriod14', 'status'],
  },
  latestFall: {
    name: 'last Fall',
    resource: 'latest_fall',
    columnsIds: ['lastFall'],
  },
  currentEpisodeOfCare: {
    name: 'currentEpisodeOfCare',
    resource: 'current_episode_of_care',
    columnsIds: ['typeOfCare', 'payor'],
  },
  gaitTrend: {
    name: 'gaitTrend',
    resource: 'gait_trend',
    columnsIds: ['gaitTrend'],
  }
};

export const patientResources = [
  ...map(pickBy(columnsCategories, 'resource'), 'resource'),
  columnsCategories.therapistTime.resource,
].join(',');

export default columnsCategories;
